import React, { useState, useEffect } from "react";
import firebase from "gatsby-plugin-firebase";

export const UserContext = React.createContext(undefined);

const Provider = (props) => {
  // Monitor the user's authentication state
  // We use undefined here to distinguish between not having read
  // the authentication state (undefined) and the user not being
  // logged in (null)
  const [currentUser, setCurrentUser] = useState(undefined);

  // Update user authentication state
  useEffect(() => {
    firebase.auth().onAuthStateChanged((user) => {
      user ? setCurrentUser(user) : setCurrentUser(null);
    });
  });

  return (
    <UserContext.Provider value={currentUser}>
      {props.children}
    </UserContext.Provider>
  );
};

export default Provider;
